export const environment = {
  production: false,
  defaultToken: "",
  builderApiKey: "6336f9fc0d2e4508967511ce706e655f",
};
